var _class, _temp;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { Component } from 'react';
import './devices.min.css';
var DeviceList = ['iphonex', 'galaxynote8', 'iphone8', 'iphone8plus', 'iphone5s', 'iphone5c', 'ipadmini',
// 'iphone4s',
'nexus5',
// 'lumia920',
'galaxys5',
// 'htcone',
'macbookpro'];
var _default = (_temp = _class = function (_Component) {
  _inherits(_default, _Component);
  function _default(props) {
    _classCallCheck(this, _default);
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
    _this.state = {
      position: props.position,
      color: props.color
    };
    return _this;
  }
  _default.prototype.scaleView = function scaleView() {
    return {
      WebkitTransform: 'scale(' + this.props.scale + ')',
      transform: 'scale(' + this.props.scale + ')'
    };
  };
  _default.prototype.wrp = function wrp(n) {
    return 'marvel-device ' + n + ' ' + this.state.position + ' ' + this.state.color;
  };
  _default.prototype.iphonex = function iphonex() {
    return React.createElement('div', {
      className: this.wrp('iphone-x'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'notch'
    }, React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'speaker'
    })), React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'bottom-bar'
    }), React.createElement('div', {
      className: 'volume'
    }), React.createElement('div', {
      className: 'overflow'
    }, React.createElement('div', {
      className: 'shadow shadow--tr'
    }), React.createElement('div', {
      className: 'shadow shadow--tl'
    }), React.createElement('div', {
      className: 'shadow shadow--br'
    }), React.createElement('div', {
      className: 'shadow shadow--bl'
    })), React.createElement('div', {
      className: 'inner-shadow'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children));
  };
  _default.prototype.galaxynote8 = function galaxynote8() {
    return React.createElement('div', {
      className: this.wrp('note8'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'inner'
    }), React.createElement('div', {
      className: 'overflow'
    }, React.createElement('div', {
      className: 'shadow'
    })), React.createElement('div', {
      className: 'speaker'
    }), React.createElement('div', {
      className: 'sensors'
    }), React.createElement('div', {
      className: 'more-sensors'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'volume'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children));
  };
  _default.prototype.iphone8 = function iphone8() {
    return React.createElement('div', {
      className: this.wrp('iphone8'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'volume'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'sensor'
    }), React.createElement('div', {
      className: 'speaker'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children), React.createElement('div', {
      className: 'home'
    }), React.createElement('div', {
      className: 'bottom-bar'
    }));
  };
  _default.prototype.iphone8plus = function iphone8plus() {
    return React.createElement('div', {
      className: this.wrp('iphone8plus'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'volume'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'sensor'
    }), React.createElement('div', {
      className: 'speaker'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children), React.createElement('div', {
      className: 'home'
    }), React.createElement('div', {
      className: 'bottom-bar'
    }));
  };
  _default.prototype.iphone5c = function iphone5c() {
    return React.createElement('div', {
      className: this.wrp('iphone5c'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'volume'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'sensor'
    }), React.createElement('div', {
      className: 'speaker'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children), React.createElement('div', {
      className: 'home'
    }), React.createElement('div', {
      className: 'bottom-bar'
    }));
  };
  _default.prototype.iphone5s = function iphone5s() {
    return React.createElement('div', {
      className: this.wrp("iphone5s"),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'volume'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'sensor'
    }), React.createElement('div', {
      className: 'speaker'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children), React.createElement('div', {
      className: 'home'
    }), React.createElement('div', {
      className: 'bottom-bar'
    }));
  };
  _default.prototype.ipadmini = function ipadmini() {
    return React.createElement('div', {
      className: this.wrp('ipad'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children), React.createElement('div', {
      className: 'home'
    }));
  };
  _default.prototype.macbookpro = function macbookpro() {
    return React.createElement('div', {
      className: this.wrp("macbook"),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children), React.createElement('div', {
      className: 'bottom-bar'
    }));
  };
  _default.prototype.galaxys5 = function galaxys5() {
    return React.createElement('div', {
      className: this.wrp('s5'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'sensor'
    }), React.createElement('div', {
      className: 'speaker'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children), React.createElement('div', {
      className: 'home'
    }));
  };
  _default.prototype.nexus5 = function nexus5() {
    return React.createElement('div', {
      className: this.wrp('nexus5'),
      style: this.scaleView()
    }, React.createElement('div', {
      className: 'top-bar'
    }), React.createElement('div', {
      className: 'sleep'
    }), React.createElement('div', {
      className: 'volume'
    }), React.createElement('div', {
      className: 'camera'
    }), React.createElement('div', {
      className: 'screen'
    }, this.props.children));
  };
  _default.prototype.render = function render() {
    var _this2 = this;

    /* check device */
    var device = DeviceList.find(function (d) {
      return d === _this2.props.device;
    });
    if (device) {
      return this[device]();
    }
    return null;
  };
  return _default;
}(Component), _class.defaultProps = {
  device: 'iphonex',
  position: '',
  // landscape
  color: '',
  scale: 1.0
}, _temp);
export { _default as default };